import { render, staticRenderFns } from "./create-lpn-label.vue?vue&type=template&id=268d1867&"
import script from "./js/create-lpn-label.js?vue&type=script&lang=js&"
export * from "./js/create-lpn-label.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports